<template>
    <div class="home-page" style="width: 100%; position: relative">
        <page-header-block></page-header-block>
<!--        :class="[showCases?'show-tab':'hidden-tab' ]"-->
        <transition name="fade" v-on:enter="menuChange" v-on:leave="menuLeave">
            <div class="successful-cases-tab"  @mouseleave="changeShow" v-show="showCases">
                <div class="tab-item" v-for="(item,index) in casesTabList">
                    <div class="item-title">{{item.title}}</div>
                    <div class="item-list" @click="selectPage(index,itemsIndex)" v-for="(items,itemsIndex) in item.list"
                         v-if="item.list.length>0" style="cursor: pointer;" >
                        {{items.title}}
                    </div>
                </div>
            </div>
        </transition>
<!--        <div style="margin-top: 100px">-->
<!--            <div id="demo">-->
<!--                <button v-on:click="changeShowDemo">-->
<!--                    Toggle-->
<!--                </button>-->
<!--                <transition name="fade" v-on:enter="menuChange" v-on:leave="menuLeave">-->
<!--                    <div v-if="show" style="height: 100px; background: #333333;color: red">hello</div>-->
<!--                </transition>-->
<!--            </div>-->
<!--        </div>-->
        <router-view/>
        <page-footer-block></page-footer-block>

    </div>
</template>

<script>
    import PageHeaderBlock from '../../components/page-header-footer/page-header-block'
    import PageFooterBlock from '../../components/page-header-footer/page-footer-block'
    export default {
        name: "home-page",
        components:{
            PageHeaderBlock,
            PageFooterBlock
        },
        data(){
            return{
                // isPC:true, // 判断是否为手机浏览器
                casesTabList:[
                    {title:'电力',list:[{title:'无锡镇江电力物联网系统',path:'/page/cases?index=0&id=first'},{title:'江阴青禾绿色微电网项目',path:'/page/cases?index=0&id=second'},
                            {title:'建德变电站智慧平台',path:'/page/cases?index=0&id=third'}]},
                    {title:'园区',list:[{title:'化工园区二道门智能化管理系统',path:'/page/cases?index=1&id=first'},{title:'化工园区二道门人员定位解决方案',path:'/page/cases?index=1&id=second'},
                            {title:'安环眼·智能巡检',path:'/page/cases?index=1&id=third'}]},
                    {title:'农业',list:[{title:'睢宁智慧农业物联网',path:'/page/cases?index=2&id=first'},{title:'青禾农场智慧化提升综合示范项目',path:'/page/cases?index=2&id=second'},
                            {title:'青禾二期农业智慧平台',path:'/page/cases?index=2&id=third'}]},
                    {title:'环保',list:[{title:'飞灰云智系统',path:'/page/cases?index=3&id=first'},{title:'飞灰填埋云智系统',path:'/page/cases?index=3&id=second'},]},
                    {title:'城管',list:[{title:'户外广告系统',path:'/page/cases?index=4&id=first'},]},
                    {title:'校园',list:[
                            {title:'南京市同仁小学官网',path:'/page/cases?index=5&id=first'},
                            {title:'学习者课堂评价系统',path:'/page/cases?index=5&id=second'},
                        ]},
                ],
                showCases:false,
                show:true,
                listLength:0 //下拉列表最高
            }
        },
        mounted() {
            //动态获取浏览器宽度
            window.onresize = () => {
                var _this = this;
                _this.$store.state.screenWidth = document.documentElement.clientWidth; //窗口宽度
            }
            //获取浏览器是否为手机浏览器方法
            // var ua = window.navigator.userAgent,
            //     agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad'],
            //     isPC = true;
            // console.log(ua)
            // for (var i = 0, len = agents.length; i < len; i++) {
            //     if (ua.indexOf(agents[i]) > 0) {
            //         // 如果找到一个手机标识, 就设置为false并跳出循环
            //         this.isPC = false;
            //         console.log(agents[i]);
            //         break;
            //     }
            // }
            // 判断如果不是pc端就将网页路由替换为手机端
            // if (!isPC) {
            //     // 假设现在网址为： https://xxx.xxx.com/2020
            //     var href = window.location.href.replace('/2020/','/2020/m/');
            //     window.location.href = href;
            // }
            //获取下拉菜单最多项
            let listLength = this.casesTabList[0].list.length;
            this.casesTabList.forEach(item =>{
                if(item.list.length > listLength){
                    listLength = item.list.length
                }
            });
            this.listLength = listLength
        },
        methods:{
            /**
             * 控制显示案例下拉菜单
             * @param type
             * @param isShow
             */
            changeShow(type,isShow = false){
                if(type && type === 1){
                    this.showCases = !this.showCases;
                }else{
                    this.showCases = isShow;
                }

            },
            /**
             * 选择案例菜单
             * @param index
             */
            selectPage(index,itemsIndex){
                this.changeShow();
                this.$router.push(this.casesTabList[index].list[itemsIndex].path);
            },
            /**
             * 下拉动画触发
             * @param e
             * @param done
             */
            menuChange(e,done){
                e.offsetWidth;
                // console.log('menu',e);
                //下拉区域高度赋值
                e.style.maxHeight =  this.listLength * 200 + 'px';
                e.style.transition = "all .6s linear";
                // console.log(e.style.transition);
                done();
            },
            /**
             * 下拉动画结束
             * @param e
             */
            menuLeave(e){
                e.offsetWidth;
                e.style.maxHeight = 0;
                e.style.transition = "all .4s linear";
                // console.log(e.style.transition);
            }
        }

    }
</script>

<style lang="scss" src="./index.scss" scoped>

</style>
